import { useMemo, useState } from 'react';
import { ChangeOwnershipContext } from './ChangeOwnershipContext';
import { ChangeOwnershipStatus, NewCustomer, OwnerData, productSignaling } from '../../models/OwnershipChange';

const ChangeOwnershipProvider = ({ children }: { children: React.ReactNode }) => {
    const [owner, setOwner] = useState<OwnerData>({
        name: '',
        firstSurname: '',
        secondSurname: '',
        documentNumber: '',
        contactPhone: '',
        documentType: '',
    });
    const [selectedProduct, setSelectedProduct] = useState<productSignaling>({
        productId: '',
        productOfferingId: '',
    });
    const [dataChangeOwnership, setDataChangeOwnership] = useState<ChangeOwnershipStatus | null>(null);
    const [partyRoleId, setPartyRoleId] = useState('');
    const [partyRoleType, setPartyRoleType] = useState('');
    const [newCustomer, setNewCustomer] = useState<NewCustomer>({
        name: '',
        firstSurname: '',
        secondSurname: '',
        contactPhone: '',
        iban: '',
        geographicSiteId: '',
        email: '',
    });
    const [ibanInterested, setIbanInterested] = useState('');
    const [flowStartUrl, setFlowStartUrl] = useState('');
    const [contactMediaOTP, setContactMediaOTP] = useState('');
    const [contactMediaOTPId, setContactMediaOTPId] = useState('');
    const [customerId, setCustomerId] = useState('');
    const [isOpenOnboarding, setIsOpenOnboarding] = useState(false);

    const resetData = () => {
        localStorage.setItem('changeOwnershipFlow', 'notNewCustomer');
        setOwner({
            name: '',
            firstSurname: '',
            secondSurname: '',
            documentNumber: '',
            contactPhone: '',
            documentType: '',
        });
        setSelectedProduct({
            productId: '',
            productOfferingId: '',
        });
        setDataChangeOwnership(null);
        setPartyRoleId('');
        setPartyRoleType('');
        setNewCustomer({
            name: '',
            firstSurname: '',
            secondSurname: '',
            contactPhone: '',
            iban: '',
            geographicSiteId: '',
            email: '',
        });
        setIbanInterested('');
        setContactMediaOTP('');
        setContactMediaOTPId('');
        setCustomerId('');
    };

    const value = useMemo(
        () => ({
            owner,
            setOwner,
            selectedProduct,
            setSelectedProduct,
            dataChangeOwnership,
            setDataChangeOwnership,
            partyRoleId,
            setPartyRoleId,
            partyRoleType,
            setPartyRoleType,
            newCustomer,
            setNewCustomer,
            ibanInterested,
            setIbanInterested,
            flowStartUrl,
            setFlowStartUrl,
            resetData,
            contactMediaOTP,
            setContactMediaOTP,
            contactMediaOTPId,
            setContactMediaOTPId,
            customerId,
            setCustomerId,
            isOpenOnboarding,
            setIsOpenOnboarding,
        }),
        [
            owner,
            selectedProduct,
            dataChangeOwnership,
            partyRoleId,
            partyRoleType,
            newCustomer,
            ibanInterested,
            flowStartUrl,
            contactMediaOTP,
            contactMediaOTPId,
            customerId,
            isOpenOnboarding,
        ],
    );

    return <ChangeOwnershipContext.Provider value={value}>{children}</ChangeOwnershipContext.Provider>;
};

export default ChangeOwnershipProvider;
